import { render } from "./AvatarUploadModal.vue?vue&type=template&id=f83a1bf0&ts=true"
import script from "./AvatarUploadModal.vue?vue&type=script&lang=ts"
export * from "./AvatarUploadModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__